import VideoDialog from '.';
import type { Meta, StoryObj } from '@storybook/vue3';

const meta = {
  title: 'Molecules/VideoDialog',
  component: VideoDialog,
  render: (args, { globals }) => ({
    components: { VideoDialog },
    setup() {
      return { args, globals };
    },
    template: '<videoDialog v-bind="args">{{ args.default }}</videoDialog>',
  }),
  tags: ['autodocs'],
  argTypes: {
    // Add argTypes here
  },
  args: { youtubeId: 'dQw4w9WgXcQ', byPassConsent: true },
} satisfies Meta<typeof VideoDialog>;

export default meta;
type Story = StoryObj<typeof meta>;

export const Youtube: Story = {
  ...meta,
  args: {
    ...meta.args,
  },
};

export const NativeUpload: Story = {
  ...meta,
  args: {
    youtubeId: undefined,
    videos: [
      {
        path: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4',
        extension: 'mp4',
        name: 'esome_EWI_Netflix_6s_Bumper_V5.mp4',
        title: 'EWI Netflix Bumper',
      },
    ],
  },
};
